<template>
    <div ref="mainHigh" class="mianLogin">
        <div class="logoTop">
            <div class="imgs">
                <img src="@/assets/img/logo_notext.png" alt="">
            </div>
            <h3>高企助手</h3>
        </div>
        <div class="input-groud">

            <div class="item">
                <i>*</i>
                <single-select size="large" style="width:90%;margin:.5rem 0" placeholder="请选择所属园区" v-model:value="form.affiliatedPark" :options="options" @change="getCompanyByBaseId"
                    titleName="baseName" valueName="id" />
            </div>
            <div class="item">
                <i>*</i><input v-model="form.companyName" type="text" placeholder="请输入企业名称">
            </div>
            <div class="item">
                <i>*</i><input v-model="form.contactName" type="text" placeholder="请输入联系人">
            </div>
            <div class="item">
                <i>*</i><input v-model="form.contactPhone" type="tel" maxlength="11" placeholder="请输入联系电话">
            </div>
            <div class="item">
                <i>*</i><input v-model="form.watc" type="text" placeholder="请输入验证码">
            </div>
            <div class="captchaCode">
<!--                <canvas @click="generateCaptcha" ref="captchaCanvas" width="120" height="30"></canvas>-->
<!--              <a-button style="cursor: pointer;color: red" @click="getPhoneCode()">{{ codeBtnWord }}</a-button>-->
              <a-button
                style="background:rgba(0, 88, 180);border:none;cursor: pointer;color: #fff;position: relative;z-index: 2;"
                ref="codeBtnWordBtn"
                @click="getPhoneCode()"
              >
                {{ codeBtnWord }}
              </a-button>
              <div class="codeBtnWordMark" ref="codeBtnWordMarkid"></div>
            </div>
        </div>
        <a-button class="subtn" size="large" @click="submit" type="primary">立即注册</a-button>
        <span class="subtn" style="margin-top:-.5rem;font-size:1rem;background:none"
            @click="goMore('/webHighEnterpriseEvaluation/login')">已有账号，立即登录</span>
    </div>
</template>

<script>
// import { innovationBaseInfo,phoneCommon } from "@/api/finance";
import {innovationBaseInfo, phoneCommon} from "@/api/finance";
import { basicsEvaluateUsers } from "@/api/webHighEnterpriseEvaluation";
import {notification} from "ant-design-vue";

export default {

    data() {
        return {
            captcha: null,
            options: null,
            optionCampany: null,
            codeBtnWord: '获取短信验证码',
            form: {
                affiliatedPark: null,
                contactPhone: null,
                contactName: null,
                companyName: null,
                watc: null,
            },
          // waitTime: 61,
          // screenWidth: document.documentElement.clientWidth
        }
    },
    mounted() {
        this.getInnovationBaseInfo()
        this.$refs.mainHigh.style.height = window.innerHeight + 'px'
        // this.generateCaptcha();//验证码
    },
    methods: {
      getPhoneCode() {
        let that=this
        const phoneReg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!phoneReg.test(this.form.contactPhone)) {
          alert('请输入正确的手机号码！')
          return
        } else {
          this.postAction({
              url: phoneCommon.sealSMS,
              params: {
                phone: this.form.contactPhone
              }
            }).then((res) => {
            if (res.code === '0') {
              this.waitTime = (res.msg * 60) + 1
              this.waitTime--;
              this.$refs.codeBtnWordMarkid.style.zIndex = -1;
              this.codeBtnWord = `${this.waitTime}s 后获取`;
              let timer = setInterval(() => {
                if (this.waitTime > 1) {
                  this.waitTime--;
                  this.codeBtnWord = `${this.waitTime}s 后获取`;
                } else {
                  clearInterval(timer);
                  this.codeBtnWord = "获取短信验证码";
                  this.$refs.codeBtnWordMarkid.style.zIndex = -1
                  this.waitTime = 61;
                }
              }, 1000);
              notification.success({
                message: '验证码发送成功，请查看手机短信',
                placement: 'topLeft',
                style: {
                  width: '400px',
                  fontWeight: '600',
                  marginLeft: `-${that.screenWidth/2-200}px`,
                  marginTop: `${20}%`,
                }
              });
            }else if (res.code === '1') {
              notification.success({
                message: '验证码发送失败，请稍后重新发送',
                placement: 'topLeft',
                style: {
                  width: '400px',
                  fontWeight: '600',
                  marginLeft:  `-${that.screenWidth/2-200}px`,
                  marginTop: `${20}%`,
                }
              });
            } else if (res.code === '2') {
              notification.success({
                message: res.msg,
                placement: 'topLeft',
                style: {
                  width: '400px',
                  fontWeight: '600',
                  marginLeft: `-${that.screenWidth/2-200}px`,
                  marginTop: `${20}%`,
                }
              });
            } else if (res.code === '3') {
              notification.success({
                message: res.msg,
                placement: 'topLeft',
                style: {
                  width: '400px',
                  fontWeight: '600',
                  marginLeft:  `-${that.screenWidth/2-200}px`,
                  marginTop: `${20}%`,
                }
              });
            }
          })
        }
      },
        getCompanyByBaseId(ID) {
            this.optionCampany =null
            this.form.companyCode = null
            this.getAction({
                url: basicsEvaluateUsers.queryCompanyInfo,
                params:{
                    id:ID
                }
            }
            ).then((res) => {
                this.optionCampany = res
            })
        },
        getInnovationBaseInfo() {
            this.getAction({
                url: innovationBaseInfo.list,
            }
            ).then((res) => {
                console.log('所属园区', res)
                this.options = res
            })
        },
        saveOrUpdate(form){
            this.postAction({
                url: basicsEvaluateUsers.saveOrUpdate,
                params: form
            }
            ).then((res) => {
                if(res){
                    alert('注册成功')
                    this.$router.push('/webHighEnterpriseEvaluation/login')
                    this.$ls.set("wxLoginPhone", this.form.contactPhone)
                }
            })
        },
        submit() {
            if (this.form.affiliatedPark && this.form.contactPhone && this.form.contactName && this.form.companyName && this.form.watc) {
                const phoneReg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
                if (!phoneReg.test(this.form.contactPhone)) {
                    alert('请输入正确的手机号码！')
                } else {
                  this.postAction({
                    url: phoneCommon.sealSMSCheck,
                    params: {
                      code: this.form.watc,
                      phone: this.form.contactPhone
                    }
                  }).then((res) => {
                    if (res) {
                      this.saveOrUpdate(this.form)
                    } else {
                      notification.error({
                        message: '验证码有误，请输入正确验证码',
                        duration: 10,
                        style: {
                          width: '400px',
                          fontWeight: '600',
                          marginTop: `${10}%`,
                        },
                      });
                    }
                  })
                   /* if (this.form.watc.toLowerCase() == this.captcha.toLowerCase()) {
                        this.saveOrUpdate(this.form)
                    } else {

                        this.generateCaptcha();//验证码
                        alert('请输入正确的验证码！')
                    }*/
                }
            } else {
                console.log(this.form)
                alert('请检查必填项！')
            }
        },
        //路由跳转
        goMore(url, str) {
            if (str) {
                this.$router.push({ path: url, query: { id: str } })
            } else {
                this.$router.push(url)
            }
        },
        //验证码部分start
        generateCaptcha() {
            const canvas = this.$refs.captchaCanvas;
            const ctx = canvas.getContext('2d');

            // 验证码背景色\
            ctx.fillStyle = 'rgb(220, 255, 255)'
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // 验证码字符集
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

            // 生成4位随机验证码
            let captcha = '';
            for (let i = 0; i < 4; i++) {
                const char = characters[Math.floor(Math.random() * characters.length)];

                // 随机生成字符的颜色
                const color = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`;
                ctx.fillStyle = color;
                ctx.font = 'bold 36px Arial';
                ctx.fillText(char, 30 * i, 28);

                captcha += char;
            }

            // 将生成的验证码存储起来或发送给后端进行验证
            this.captcha = captcha
            console.log('生成的验证码:', captcha);

        }
        //验证码部分end
    }
};
</script>
<style lang="less" scoped>
:deep(.ant-select:not(.ant-select-disabled):hover .ant-select-selector) {
    border-color: #f1f1f1
}

:deep(.ant-select-focused:not(.ant-select-disabled) .ant-select:not(.ant-select-customize-input) .ant-select-selector) {
    border-color: #f1f1f1
}

.mianLogin {
    font-family: '微软雅黑';
    width: 100%;
    background: url(./img/bg.jpg) no-repeat;
    background-size: 100% 100%;
    display: flex;
    font-size: 1.1rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .logoTop {
        margin-bottom: 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 90vw;
        font-weight: bold;

        .imgs {
            border-radius: 8rem;
            width: 8rem;
            height: 8rem;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: .5rem;
        }
    }

    .input-groud {
        margin-bottom: 2rem;
        display: flex;
        flex-direction: column;
        width: 90vw;
        overflow: auto;
        padding: 1rem;
        background: #fff;
        position: relative;
        border-radius: .4rem;

        .captchaCode {
            position: absolute;
            right: 4.5rem;
            bottom: 1rem;
            z-index: 999;
            color: #000;
          padding: 8px 10px;
          font-size: 16px ;
        }
      .codeBtnWordMark {
        width: 100%;
        height: 40px;
        //background: rgba(0, 88, 180);
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
      }
        i {
            color: red;
            width: 1rem;
            display: inline-block;
        }

        input {
            width: 92%;
            font-size: 1rem;
            color: #3d3d3d;
            padding: .5rem;
            border: 0;
            line-height: 2rem;

            &:focus {
                border-style: none;
                outline: none;
            }
        }
    }

    .subtn {
        width: 90vw;
        font-size: 1.1rem;
        padding: .8rem 0 2.4rem;
        background: #1c4ff7;
        text-align: center;
    }
}</style>
